import { SSPA } from "../constants/sspa";
import { getAppName } from "../utils/url";
// @ts-ignore
import { ClientService, APPS as APP_INFO } from '@cosmos/utilities';
import { navigateToUrl } from "single-spa";

export class LoaderService {
  private loader: HTMLElement;
  private static loaderService: LoaderService;

  private constructor() {
    this.loader = document.querySelector(SSPA.loaderId);
  }

  static singleton(): LoaderService {
    if (!LoaderService.loaderService) {
      LoaderService.loaderService = new LoaderService();
    }
    return LoaderService.loaderService;
  }

  show() {
    let appName = getAppName(window.location.href);
    let appImage = '';
    if (!appName) {
      appName = 'plataforma';
      navigateToUrl(`/${appName}`);
    }

    const appInfo: AppInfoDetails = APP_INFO[`${appName}`];
    appImage = appInfo?.image
    appName = appInfo?.name

    if(appInfo?.chave_sistema === APP_INFO['plataforma'].chave_sistema) {
      const dataObject = this.getClientData()

      appImage = dataObject.appImage;
      appName = dataObject.appName;
    }

    this.loader.innerHTML = `
      <img src="${appImage || ''}" alt="Logo do sistema ${appName || ''}"/>
      <p>Carregando ${appName || ''}...</p>
      <div class="sspa-launcher__loader"></div>
    `;
      
    if(appInfo.chave_sistema === APP_INFO['semchamada'].chave_sistema) {
      var ckeditorScript = document.createElement('script');
      ckeditorScript.setAttribute('src','https://cdn.ckeditor.com/4.10.1/full/ckeditor.js');
      document.head.appendChild(ckeditorScript);
    }
  }

  toString(appName: string): string {
    const appInfo: AppInfoDetails = APP_INFO[`${appName}`];
    let appImage = '';
    appImage = appInfo?.image
    appName = appInfo?.name
    if(appInfo?.chave_sistema === APP_INFO['plataforma'].chave_sistema) {
      const dataObject = this.getClientData()

      appImage = dataObject.appImage;
      appName = dataObject.appName;
    }

    return `
    <div style="height: 100%;width: 100%;display: flex; align-items: center; justify-content: center; flex-direction: column;">
    <img src="${appImage || ''}" alt="Logo do sistema ${appName || ''}"/>
    <p>Carregando ${appName || ''}...</p>
    <div class="sspa-launcher__loader"></div>
    </div>
  `;
  }
  
  getClientData() {
    const clientService = ClientService.singleton();
    const iconChave = clientService.parametrosChaves.iconUrl || '';
    const nameChave = clientService.parametrosChaves.clientName || '';
    const dataObject = clientService.getClientDataByArrayKey([iconChave, nameChave])
    return { appImage: dataObject[iconChave], appName: dataObject[nameChave] }
  }

  hide() {
    this.loader.remove();
  }
}
